import React, { useState } from 'react';
import styled from 'styled-components';
import {ReactComponent as ArrowUp} from '../../../../../images/arrow-up.svg';
import { Box, VerticalDivider} from '../../../../styled';
import JiraIssueIcon from './JiraIssueIcon';
import JiraStatus from './JiraStatus';

interface SubtasksProps{
  subtasks?: Array<any>
}
const List = styled(Box)`
  max-height: 0;
  overflow: hidden;
  transition: all ease-in-out .3s;
  white-space: pre-wrap;
  &.open{
    max-height: 300px;
    overflow: auto;
  }
`
const Header = styled.h5`
  color: ${props => props.theme.colors.primaryBlueDark};
  font-family: Manrope, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  margin-top: 10px;
`
const Chevron = styled.span`
  margin-left: 20px;
  color: ${props => props.theme.colors.primaryBlueDark};
  transition: all ease-in-out .15s;
  & path {
    fill: ${props => props.theme.colors.primaryBlueDark};
  }
  &.reverse svg{
    transform: rotate(180deg);
  }
`
const IssueLink = styled.a`
  color: ${props => props.theme.colors.primaryBlueDark};
  padding-left: 4px;
  &:hover{
    color: ${props => props.theme.colors.primaryBlueDark};
    text-decoration: none;
  }
`

const getIssueLink = (task:any) => {
  let link = task.fields.priority?.iconUrl.split('/').slice(0, 3);
  if (!link) {
    return task.self;
  }
  link.push('browse');
  link.push(task.key);
  return link.join('/');
}
const JiraSubtasks = ({ subtasks }: SubtasksProps) => {
  const [isOpen, setIsOpen] = useState(false);
  if (!subtasks || !subtasks.length) {
    return null;
  }
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  }

  return (
    <Box>
      <Header onClick={toggleOpen}>
        Child issues
        <Chevron className={isOpen ? 'reverse' : ''}><ArrowUp /></Chevron>
      </Header>
      <List className={isOpen ? 'open' : ''}>
        {subtasks.map(task => (
          <Box
            key={task.id}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-between'}
            marginBottom={2}
            padding={2}
            borderRadius={6}
            backgroundColor={'#fff'}
          >
            <Box display={'flex'} flex={1} alignItems={'center'}>
              <JiraIssueIcon type={task.fields.issuetype?.name} data={task.fields.issuetype} hideName />
              <IssueLink target={'jira'} href={getIssueLink(task)}>
                {task.key} {task.fields.summary}
              </IssueLink>
            </Box>
            <Box
              display={'flex'}
              alignItems={'center'}
            >
              {task.fields.priority.iconUrl && (
                <>
                  <img height="18" width="18" src={task.fields.priority.iconUrl} alt='priority icon' />
                  <VerticalDivider height={14} />
                </>
              )}
              <JiraStatus status={task.fields.status.name} />
            </Box>
          </Box>
        ))}
      </List>
    </Box>
  )
}

export default JiraSubtasks;